import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { searchApi } from 'apis/search';
import { PhoneNumberCountryFlag } from 'components/phoneNumberCountryFlag';
import { usePaginatedEndpoint } from 'utils/apis/pagination/usePaginatedEndpoint';
import { searchUserToPhoneNumberSelectItem } from './utils/userToSelectItem';
/** Represents the component for selecting a phone number. */
export const PhoneNumberUserSelect = ({ className, phoneNumber, infiniteScroll = false, showRegionFlagPrefix, onSelect, onToggle, status, }) => {
    const { arg, asyncStatus, hasNextPage, hasPreviousPage, items: users, nextPage, previousPage, search, } = usePaginatedEndpoint({
        endpoint: searchApi.endpoints.readSearchUser,
        initialArg: {
            sort: {
                key: 'display_name',
            },
            filter: {
                facets: {
                    has_phone_number: [true],
                },
            },
        },
        itemsSelector: ({ data }) => data.results.hits,
        infinite: infiniteScroll,
    });
    /** Handles selecting a phone number. */
    const handleSelect = useCallback((item) => {
        var _a;
        const searchUserHit = users.find(({ phone_number }) => phone_number === item.id);
        onSelect({
            searchUserHit,
            phoneNumber: (_a = searchUserHit === null || searchUserHit === void 0 ? void 0 : searchUserHit.phone_number) !== null && _a !== void 0 ? _a : item.name,
        });
    }, [onSelect, users]);
    /** Handles toggling the dropdown of the select component. */
    const handleToggle = useCallback((isOpen) => {
        var _a;
        if (isOpen) {
            search((_a = arg === null || arg === void 0 ? void 0 : arg.searchTerm) !== null && _a !== void 0 ? _a : '', { debounceTime: 0 });
        }
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(isOpen);
    }, [arg === null || arg === void 0 ? void 0 : arg.searchTerm, onToggle, search]);
    /** Handles navigating to the next page. */
    const handleNextPage = useCallback(() => {
        return Promise.resolve(nextPage());
    }, [nextPage]);
    /** Handles navigating to the previous page. */
    const handlePreviousPage = useCallback(() => {
        return Promise.resolve(previousPage());
    }, [previousPage]);
    return (_jsx(Select, { status: status, prefix: showRegionFlagPrefix
            ? {
                type: 'custom',
                value: _jsx(PhoneNumberCountryFlag, { phoneNumber: phoneNumber }),
                noWrap: false,
            }
            : undefined, className: className, emptyMessage: (arg === null || arg === void 0 ? void 0 : arg.searchTerm)
            ? 'No phone numbers found'
            : 'No phone numbers available', items: 
        // the search term is added as a select item,
        // but it empty search is not an onption.
        (arg === null || arg === void 0 ? void 0 : arg.searchTerm) && arg.searchTerm != ''
            ? [
                {
                    id: arg.searchTerm,
                    name: arg.searchTerm,
                },
                ...users.map((user) => searchUserToPhoneNumberSelectItem(user)),
            ]
            : [...users.map((user) => searchUserToPhoneNumberSelectItem(user))], loading: asyncStatus === 'pending', onSearch: (value) => search(value, { debounceTime: 300 }), onSelect: handleSelect, onToggle: handleToggle, pagination: {
            infinite: infiniteScroll,
            nextEnable: hasNextPage,
            previousEnable: hasPreviousPage,
            onNext: handleNextPage,
            onPrevious: handlePreviousPage,
        }, placeholder: "Type a phone number or user name", searchable: true, selectedItems: phoneNumber ? [phoneNumber] : [] }));
};
